export const RESET_CANCELLATIONS = 'RESET_CANCELLATIONS'
export const SET_CANCELLATIONS = 'SET_CANCELLATIONS'
